@if (!status || status.busy) {
  <div [dfs]="'p-a:4'"
    >
    @switch (variant) {
      @case ('default') {
        <ng-container *ngTemplateOutlet="defaultTemplate"></ng-container>
      }
      @case ('media') {
        <ng-container *ngTemplateOutlet="mediaTemplate"></ng-container>
      }
    }
  </div>
}
@if (status?.error) {
  <p
  [dfs]="'t:p2 c:2 m-v:12px'">{{status!.error}}</p>
}


<!-- TEMPLATES -->

<ng-template #defaultTemplate>
  @for (_ of lines; track _; let first = $first) {
    <div [dfs]="['br:50', !first && 'm-t:2']"
      class="_line _waveBackgroundEffect">
    </div>
  }
</ng-template>

<ng-template #mediaTemplate>
  <div [dfs]="'d:grid'"
    [style.columnGap.px]="8"
    [style.rowGap.px]="8"
    [style.gridTemplateColumns]="'repeat('+numberOfColumns+', minmax(0, 1fr))'">
    @for (_ of squares; track _) {
      <div>
        <div class="_square _waveBackgroundEffect">
        </div>
        <div class="_line _waveBackgroundEffect"
        [dfs]="'m-t:2 br:50'"></div>
      </div>
    }
  </div>
</ng-template>